import React, { useState, useEffect } from "react";
// import Logo from "../home/img/banner/b30.png";
import { MdEmail } from "react-icons/md";
import { FaMapMarkedAlt } from "react-icons/fa";
import { IoCall, IoTime } from "react-icons/io5";
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";
import Loader from "../home/Loader";
import "./about.css";
import PageTitle from "../store/PageTitle";
import { fetchFooter } from "../store/action/contentAction";
import { FaFacebook } from "react-icons/fa";
import { CiInstagram } from "react-icons/ci";
import { useSelector, useDispatch } from "react-redux";
import "../home/home.css";

const serverUrl = process.env.REACT_APP_SERVER_URL;

function Contact() {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await fetch(`${serverUrl}/api/send-email`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Received Successfully!",
          text: "Email Received Successfully, will get back to you in sec!",
          confirmButtonText: "Okay",
        });

        setFormData({ name: "", email: "", subject: "", message: "" });
      } else {
        toast.error("Failed to send message.");
      }
    } catch (error) {
      console.error("Error sending message:", error);
      toast.error("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  // const handleSoon = () => {
  //   Swal.fire({
  //     icon: "warning",
  //     title: "Coming Soon",
  //     text: "Newsletter will be available soon",
  //     confirmButtonText: "Okay",
  //   });
  // };

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchFooter());
  }, [dispatch]);

  const footerData = useSelector((state) => state.footer.data) || [];

  return (
    <div>
      <PageTitle title="Contact Us" />
      <section id="page-header" className="contact-header">
        <h2> CITY GAMERS & ELECTRONICS WORLD</h2>
        <p>Your World of Quality Electronics</p>
      </section>
      <section id="contact-details" className="section-pl">
        {footerData.map((item) => (
          <div className="contact--details--inbox">
            <div className="details">
              <h2>Contact Details</h2>
              <div>
                <li>
                  <i className="fa fa-map">
                    <FaMapMarkedAlt />
                  </i>
                  <p>{item.address}</p>
                </li>
                <li>
                  <i className="fa fa-envelope">
                    <MdEmail />
                  </i>
                  <p>{item.email}</p>
                </li>
                <li>
                  <i className="fa fa-phone-alt">
                    <IoCall />
                  </i>
                  <p>{item.phone}</p>
                </li>
                <li>
                  <i className="fa fa-clock">
                    <IoTime />
                  </i>
                  <p>
                    {item.open} - {item.close}, Mon - Sat
                  </p>
                </li>
              </div>
            </div>
          </div>
        ))}
        <div className="map">
          <div className="cover--content"></div>
          <iframe
            title="city-stores"
            src="https://www.google.com/maps/d/u/0/embed?mid=12mRM9mBWwDQN8q6G0b-OfnjlLT85PLQ&ehbc=2E312F"
            width="600"
            height="450"
          ></iframe>
        </div>
      </section>

      <section id="form-details">
        <div className="form--contact--detaile--box">
          <div className="form--mission--box">
            <h2>Our Mission</h2>
            <p>
              At City Gamers & Electronics World, our mission is to provide an
              unparalleled shopping experience for gamers and tech enthusiasts
              alike. We are committed to offering a wide range of high-quality
              gaming products and electronics, ensuring that our customers have
              access to the latest and greatest in the industry. Our goal is to
              foster a vibrant community of gamers and tech lovers, where
              <br />
            </p>
            <h2>Core Values</h2>
            <p>
              everyone can find the perfect gear to enhance their gaming and
              technology experience. We strive to deliver exceptional customer
              service, expert advice, and a seamless shopping experience both in
              -store and online. Join us on our mission to elevate your gaming
              and tech journey!
            </p>
            <div className="follow">
              <div className="icon--container">
                <a
                  className="icons"
                  href="https://web.facebook.com/citygamersandelectronics"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaFacebook />
                </a>
                <a className="icons" href="mailto:citygamersword@gmail.com">
                  <MdEmail />
                </a>

                <a
                  className="icons"
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <CiInstagram />
                </a>
              </div>
            </div>
          </div>
          <div className="form--contact--message--box">
            <form onSubmit={handleSubmit}>
              <h2>Please Message Us</h2>
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="subject"
                placeholder="Subject"
                value={formData.subject}
                onChange={handleChange}
                required
              />
              <textarea
                name="message"
                cols="30"
                rows="10"
                placeholder="Your Message ...."
                value={formData.message}
                onChange={handleChange}
                required
              />
              <button type="submit" className="normal">
                Send
              </button>
            </form>
          </div>
          {loading && <Loader />}
          <ToastContainer position="top-center" />
        </div>
      </section>
    </div>
  );
}
export default Contact;
